import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth', // Smooth scrolling for better UX
    });
  }, [pathname]); // Trigger on route change

  return null; // Component renders nothing
}

export default ScrollToTop;